import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useAccessToken } from 'store'

interface ProfileCoverProps {
    cover: string | null
    photo_count: number | undefined
    premium_video_count: number | undefined
    video_count: number | undefined
    hideCount: boolean | undefined
}

export const ProfileCover = ({
    cover,
    photo_count,
    premium_video_count,
    video_count,
    hideCount
}: ProfileCoverProps) => {
    const { t } = useTranslation()
    const isAuthenticated = useAccessToken() !== ''

    return (
        <CoverContainer
            className={isAuthenticated ? 'profilecover' : 'profilecover-unauthenticated'}
            style={{
                backgroundImage: cover
                    ? `url(${cover})`
                    : 'linear-gradient(135deg, #00cfd1, #09192d 40%, #8a003c, #ff003c)'
            }}
        >
            {!hideCount && (
                <div className='profilecover__stats'>
                    <div className='profilecover__stats--block'>
                        <div className='profilecover__stats--value'>
                            {photo_count}
                        </div>
                        <span>{t('photos')}</span>
                    </div>
                    <div className='profilecover__stats--block profilecover__stats--block--premium'>
                        <div className='profilecover__stats--value'>
                            {premium_video_count}
                        </div>
                        <span>{t('Premium')}</span>
                    </div>
                    <div className='profilecover__stats--block'>
                        <div className='profilecover__stats--value'>
                            {video_count}
                        </div>
                        <span>{t('videos')}</span>
                    </div>
                </div>
            )}
        </CoverContainer>
    )
}
const CoverContainer = styled.div`
    position: relative;
`
